import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../../store/store';
import { kbItem, addKbItem, resetKbItems } from './kbSlice';
import { toggleRightSection } from '../../store/slices/sectionSlice';
import { v4 as uuidv4 } from 'uuid';
import { unwrapResult } from '@reduxjs/toolkit';

// Define the type for the payload
interface AddKbItemPayload {
    fileName: string;
    type?: 'pdf' | 'url' | 'txt' | 'docx' | 'csv' | 'json';
    status: 'success' | 'error';
    errMessage?: string;
}

// Enhanced type definition for createAsyncThunk
export const addKbItemThunk = createAsyncThunk<kbItem, AddKbItemPayload, { state: RootState }>(
    'knowledgeBase/addKbItem',
    async (item, { getState, dispatch }) => {
        console.log("Parsed JSON chunk:", item);

        const state = getState();
        const itemExists = state.kb.items.some(existingItem => existingItem.fileName === item.fileName);
        console.log("Item exists:", itemExists);

        const newItemId = uuidv4();
        const newItem: kbItem = {
            id: newItemId,
            fileName: item.fileName,
            type: item.type,
            status: item.status === "success" ? 'succeeded' : 'failed',
            error: item.status === "error" ? item.errMessage : undefined
        };

        if (item.status === "success" && !itemExists) {
            dispatch(addKbItem(newItem));
            if (!state.section.rightOpen) {
                dispatch(toggleRightSection());
            }
        } else if (item.status === "error") {
            dispatch(addKbItem(newItem));
            console.error(`Error loading file: ${item.fileName}, Message: ${item.errMessage}`);
        } else if (itemExists) {
            return Promise.reject(new Error('Item already exists'));
        }

        return newItem;
    }
);


// Define the thunk for resetting KB items
export const resetKbItemsThunk = createAsyncThunk<void, void, { state: RootState }>(
    'knowledgeBase/resetKbItems',
    async (_, { dispatch }) => {
        // Optional: Perform any asynchronous operations here before resetting the items

        // Dispatch the resetKbItems action to reset the items in the state
        dispatch(resetKbItems());
    }
);
